<script>
    export let colorScale;
    export let hovered;
    export let legend_type;

    $: console.log(hovered)
  </script>
  
  <div class='legend' width={200} on:mouseleave={() => (hovered = null)}>
  
    {#if legend_type =='no2'}
    <p><b> Levels [ug/m3]</b></p>
    {#each colorScale.domain() as continent,i}
        <p  
        on:click={() => (hovered = i)}>
            <span style="background-color: {colorScale(continent)}" click:>
            </span>
            {continent}
        </p>
    {/each}
    {/if}
  </div>
  
  <style>

    
    .legend {
        position: absolute;
        right: 7px;
        top: 100px;
        display: flex;
        background-color: white;
      justify-content: right;
      flex-direction: column;
      flex-wrap: wrap;
      column-gap: 15px;
      padding-left: 10px;
      padding-right: 10px;
      padding-top: 10px;
      padding-bottom: 10px;
      row-gap: 5px;
      margin-bottom: 0.25rem;
      z-index: 99;
      transition: all 500ms;
      font-family: Arial;
      border-radius: 8px;
      border:2px solid rgba(177,177,177,.5);


    }
    p {
      margin: 0;
      margin-bottom: 2px;
      font-size: 0.8rem;
      text-transform: uppercase;
      display: flex;
      color: #222;
      background-color: #ffffff99;
      align-items: center;
      column-gap: 5px;
      cursor: pointer;
    }
    span {
      width: 9px;
      height: 9px;
      display: inline-block;
      border-radius: 50%;
      border: 1px solid rgba(0, 0, 0, 0);
    }
  </style>